import React from 'react';
import { Modal } from 'antd';

// CSS styles - add this to your CSS file or styled-components
const timelineStyles = `


.status-timeline {
  margin-top: 24px;
}

.status-title {
  color: #0073C6;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-icon {
  width: 20px;
  height: 20px;
  background: #0073C6;
  border-radius: 50%;
}

.timeline {
  position: relative;
  padding-left: 30px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #0073C6, #e8e8e8);
}

.timeline-item {
  position: relative;
  margin-bottom: 15px;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 10px 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.timeline-item:hover {
  box-shadow: 0 4px 12px rgba(0, 115, 198, 0.1);
  border-color: #0073C6;
}

.timeline-item::before {
  content: '';
  position: absolute;
  left: -35px;
  top: 20px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
  border: 3px solid #0073C6;
  z-index: 2;
}

.status-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #16a34a2b;
  color: #16a34a;
}

.event-time {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.patient-info {
  display: grid;
  padding-bottom: 17px;
  border-bottom: 1px solid #e8e8e8;
}

.patient-info h3 {
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
`;

const TrackEnquiry = ({ isModalVisible2, setIsModalVisible2, ticketdata }) => {
  // Your status data


  // Function to format time
  const formatTime = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    const time = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return `${day}-${month}-${year}, ${time}`;
  };


  // Sort status data by eventTime in ascending order (chronological order)
  const sortedStatusData = [...ticketdata.ticketStatusUpdates].sort(
    (a, b) => new Date(a.eventTime) - new Date(b.eventTime)
  );

  // Sort follow-ups by eventTime in ascending order
  const sortedFollowUps = [...(ticketdata.followUps || [])].sort(
    (a, b) => new Date(a.eventTime) - new Date(b.eventTime)
  );

  return (
    <>
      <style>{timelineStyles}</style>
      {isModalVisible2 && (
        <Modal
          title="Enquiry Details"
          open={isModalVisible2}
          onCancel={() => setIsModalVisible2(false)}
          footer={null}
          width={800}
        >
          <div className="patient-info">
            <h3 className='mb-0'>Patient Name: {ticketdata?.patientDetails?.patientName}</h3>
            <h3 className='mb-0'>Mobile No.: {ticketdata?.patientDetails?.mobileNumber}</h3>
            <h3 className='mb-0'>Address: {ticketdata?.patientDetails?.address}, {ticketdata?.patientDetails?.pincode}</h3>
          </div>

          {/* Status Timeline */}
          <div className="status-timeline">

            <div className='my-4'>
              <h3 className='text-base'>Patient's Query : {ticketdata?.serviceDetailsMessage}</h3>
            </div>
            <h2 className="status-title">
              <div className="status-icon"></div>
              Status Timeline
            </h2>


            {/* {sortedStatusData.map((status) => (
                <div key={status.id} className="timeline-item">
                  <div className="status-header">
                    <span className="status-badge">
                      {status.newStatus.replace('_', ' ')}
                    </span>
                    <span className="event-time">
                      {formatTime(status.eventTime)}
                    </span>
                  </div>
                </div>
              ))} */}


            {sortedStatusData && sortedStatusData.length > 0 ? (
              <div className="timeline">
                {sortedStatusData.map((status) => (
                  <div key={status.id} className="timeline-item">
                    <div className="status-header">
                      <span className="status-badge">
                        {status.newStatus.replace('_', ' ')}
                      </span>
                      <span className="event-time">
                        {formatTime(status.eventTime)}
                      </span>
                    </div>
                    {status.message && (
                      <div className="status-message" style={{
                        marginTop: '8px',
                        padding: '8px 12px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '6px',
                        borderLeft: '3px solid #0073C6',
                        fontSize: '14px',
                        color: '#333',
                        lineHeight: '1.4'
                      }}>
                        <strong>Message:</strong> {status.message}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-status-message" style={{ color: "#999", padding: "10px", fontSize: '16px' }}>
                No status updates available.
              </div>
            )}




          </div>

          {/* Follow-ups Section */}

        </Modal>
      )}
    </>
  );
};

export default TrackEnquiry;